import { SidebarBrand } from './SidebarBrand';
import { SidebarFooter } from './SidebarFooter';
import { SidebarNav } from './SidebarNav';

/**
 * Desktop side of the white L-frame — continuous with the header (no divider).
 * Width matches Ghost Screen - Home.dc.html (256px).
 */
export function Sidebar() {
  return (
    <aside
      id="app-sidebar"
      className="hidden h-full w-[256px] shrink-0 flex-col overflow-hidden lg:flex"
      style={{ background: 'var(--gs-panel)' }}
    >
      <SidebarBrand />
      <SidebarNav />
      <SidebarFooter />
    </aside>
  );
}
